import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  NgbModal,
  NgbModule,
  NgbPaginationModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MasterInformationService } from '../../../Services/master-information.service';
import { apiEndPoints } from '../../../api/apiEndPoint';
import { response } from 'express';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';

interface PriceConfig {
  id: number;
  name: string;
  capacity: string;
  weeklyCharges: number | null;
  tripCharges: number | null;
  disposalCharges: number | null;
}

@Component({
  selector: 'app-price-configuration',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgbPaginationModule,
    NgbModule,
    NgbTooltipModule,
    ReactiveFormsModule,
  ],
  templateUrl: './price-configuration.component.html',
  styleUrls: ['./price-configuration.component.css'],
})
export class PriceConfigurationComponent implements OnInit {
  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 5;

  allContainerName: any;
  containerCapacity: any;
  allContainerCapacity: any;
  containerName: any;
  priceConfigureForm: FormGroup;
  priceListContainer: any;
  isNewForm: boolean = false;
  paymentId: any;
  originalData: any[] = [];

  filterByName: boolean = true;
  filterByCapacity: boolean = false;

  filterContainerName: string = '';
  filterContainerCapacity: string = '';
  cityList: any;
  selectedCityId: any;
  changeCityId: any;
  cityId: any;

  constructor(
    private modalService: NgbModal,
    private masterService: MasterInformationService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef
  ) {
    // ----------------------------- Create Price Configure from ----------------------------- //

    this.priceConfigureForm = this.fb.group({
      cityId: ['', Validators.required],
      containerName: ['', Validators.required],
      containerCapacity: ['', Validators.required],
      containerCharges: [0, [Validators.required, Validators.min(0)]],
      tripCharges: [0, [Validators.required, Validators.min(0)]],
      disposalContainerName: [{ value: '', disabled: true }],
      disposalContainerCapacity: [{ value: '', disabled: true }],
      disposalCharges: [0, [Validators.required, Validators.min(0)]],
    });
  }

  // Filters for data
  // filters = {
  //   containerName: '',
  //   containerCapacity: '',
  // };

  // New configuration data for modal
  newConfig: PriceConfig = {
    id: 0, // Default id for new entries
    name: '',
    capacity: '',
    weeklyCharges: null,
    tripCharges: null,
    disposalCharges: null,
  };

  isModalOpen: boolean = false;
  isEditMode: boolean = false;

  // Filtered data based on the filters applied
  // get filteredData() {
  //   return this.priceListContainer.filter((item: PriceConfig) => {
  //     const matchesName = this.filters.containerName
  //       ? item.name === this.filters.containerName
  //       : true;
  //     const matchesCapacity = this.filters.containerCapacity
  //       ? item.capacity === this.filters.containerCapacity
  //       : true;
  //     return matchesName && matchesCapacity;
  //   });
  // }

  uniqueContainerNames: string[] = [];
  uniqueContainerCapacities: string[] = [];

  resetNewConfig() {
    this.newConfig = {
      id: 0, // Default value for new entries (or you could use any other logic to set a default id)
      name: '',
      capacity: '',
      weeklyCharges: null,
      tripCharges: null,
      disposalCharges: null,
    };
  }

  // Handle changes in container capacity (dropdown change)
  onContainerCapacityChange(event: any) {
    this.newConfig.capacity = event.target.value;
  }

  applyFilters(): void {
    if (this.filterByName) {
      this.priceListContainer = this.originalData.filter(
        (data: any) => data.containerName == this.filterContainerName
      );
    }

    if (this.filterByCapacity) {
      this.priceListContainer = this.originalData.filter(
        (data: any) => data.containerCapacity == this.filterContainerCapacity
      );
    }
  }

  clearFilter() {
    this.priceListContainer = this.originalData;
    this.initialContainerPriceList();
  }

  ngOnInit() {
    this.initialContainerPriceList();
    this.getCity();
  }

  // ----------------------------- Pagination ----------------------------- //
  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.priceListContainer?.slice(start, end);
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  // ------------------------------- Open Modal ------------------------------- //

  openModal(content: any, isEditMode: boolean = false) {
    this.isEditMode = isEditMode;
    this.allContainerName = [];

    if (!this.isEditMode) {
      this.priceConfigureForm.reset();
      this.priceConfigureForm.get('containerName')?.enable();
      this.priceConfigureForm.get('containerCapacity')?.enable();
      this.priceConfigureForm.get('cityId')?.enable();
    }
    this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      size: 'lg',
    });
  }

  // ---------------------- Get Container Name List API & Container change ---------------------- //

  containerNameList() {
    this.masterService.getFilteredContainer(apiEndPoints.filterContainerName, this.selectedCityId).subscribe({
      next: (response) => {
        this.allContainerName = response.body.details;
        console.log('Container name --->',this.allContainerName)
        this.containerCapacityList();
      },
      error: (error) => {
        console.error('Error adding city:', error);
        this.toastr.error(
          'An unexpected error occurred. Please try again later.',
          'Error',
          {
            timeOut: 3000,
            positionClass: 'toast-top-right',
            progressBar: true,
          }
        );
      },
    });
  }

  onContainerChange(event: any) {
    this.containerName = event.target.value;
    this.containerCapacityList();
  }

  // ---------------------- Get Container Capacity List API ---------------------- //

  containerCapacityList() {
    this.masterService
      .getContainerCapacity(
        apiEndPoints.containerCapacityList,
        this.containerName
      )
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.allContainerCapacity = response.body.details;
        },
        error: (error) => {
          console.error('Error adding city:', error);
          this.toastr.error(
            'An unexpected error occurred. Please try again later.',
            'Error',
            {
              timeOut: 3000,
              positionClass: 'toast-top-right',
              progressBar: true,
            }
          );
        },
      });
  }

  // ----------------------------------- Get All City List API ----------------------------------- //

  getCity() {
    this.masterService.getCityList(apiEndPoints.cityList).subscribe({
      next: (response: any) => {
        this.cityList = response.body.details;
      },
      error: (error) => {
        this.toastr.error('An unexpected error occurred. Please try again later.', 'Error', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
          progressBar: true
        });
      }
    })
  }

  // ----------------------------------- City Change Dropdown ----------------------------------- //

  onCityChange(event: Event) {
    const selectedCityId = (event.target as HTMLSelectElement).value;
    this.selectedCityId = selectedCityId;
    this.containerNameList();
  }

  onFilterCityChange(event: Event) {
    const selectedCityId = (event.target as HTMLSelectElement).value;
    if (selectedCityId == 'all') {
      this.initialContainerPriceList();
      return
    }
    this.changeCityId = selectedCityId;
    this.containerPriceList();
  }

  // ---------------------- Submit Container price API ---------------------- //

  onSubmit(modal: any, type: any) {
    if (type === 'new') {
      if (this.priceConfigureForm.valid) {
        const reqBody = {
          cityId: this.priceConfigureForm.value.cityId,
          containerName: this.priceConfigureForm.value.containerName,
          containerInTons: this.priceConfigureForm.value.containerCapacity,
          containerExactCapacity: this.priceConfigureForm.value.containerCapacity,
          containerRent: this.priceConfigureForm.value.containerCharges,
          tripCharges: this.priceConfigureForm.value.tripCharges,
          disposalCharges: this.priceConfigureForm.value.disposalCharges,
        };
        console.log(reqBody)
        // return
        this.masterService
          .postContainerPrice(apiEndPoints.superAdminContainerPriceConfigure, reqBody)
          .subscribe({
            next: (response: any) => {
              modal.close();
              this.toastr.success(
                'Price successfully added for the container',
                'Success',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.initialContainerPriceList();
              this.priceConfigureForm.reset();
            },
            error: (error) => {
              console.error('Error adding city:', error);
              this.toastr.error(
                'An unexpected error occurred. Please try again later.',
                'Error',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.priceConfigureForm.reset();
            },
          });
      } else {
        this.priceConfigureForm.markAllAsTouched();
      }
    } else {
      if (this.priceConfigureForm.valid) {
        const reqBody = {
          cityId: this.cityId,
          paymentId: this.paymentId,
          containerName: this.containerName,
          containerInTons: this.priceConfigureForm.value.containerCapacity,
          containerExactCapacity: this.priceConfigureForm.value.containerCapacity,
          containerRent: this.priceConfigureForm.value.containerCharges,
          tripCharges: this.priceConfigureForm.value.tripCharges,
          disposalCharges: this.priceConfigureForm.value.disposalCharges,
        };
        console.log(reqBody);
        this.masterService
          .updateContainerPriceList(apiEndPoints.superAdminUpdatePriceList, reqBody)
          .subscribe({
            next: (response: any) => {
              modal.close();
              this.toastr.success(
                'Prices successfully Changed for the container',
                'Success',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.initialContainerPriceList();
              this.priceConfigureForm.reset();
            },
            error: (error) => {
              console.error('Error adding city:', error);
              this.toastr.error(
                'An unexpected error occurred. Please try again later.',
                'Error',
                {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                  progressBar: true,
                }
              );
              this.priceConfigureForm.reset();
            },
          });
      } else {
        this.priceConfigureForm.markAllAsTouched();
      }
    }
  }

  // ---------------------- Edit Container Price API ---------------------- //

  editItem(item: any, modalContent: any) {
    this.containerName = item.containerName;
    this.containerNameList();
    this.containerCapacityList();
    console.log('EditItem --->', item)
    this.isEditMode = true;
    this.paymentId = item.id;
    this.cityId = item.cityId;

    this.priceConfigureForm.patchValue({
      cityId: item.cityId,
      containerName: this.containerName,
      containerCapacity: item.containerExactCapacity,
      containerCharges: item.containerRent,
      disposalContainerName: item.containerName,
      disposalContainerCapacity: item.containerExactCapacity,
      tripCharges: item.tripChrages,
      disposalCharges: item.disposalCharges,
    });

    // Disable specific fields
    this.priceConfigureForm.get('containerName')?.disable();
    this.priceConfigureForm.get('containerCapacity')?.disable();
    this.priceConfigureForm.get('cityId')?.disable();
    this.openModal(modalContent, true);    
    this.cd.detectChanges();
  }

  // ---------------------- Get Container Price API ---------------------- //

  containerPriceList() {
    this.masterService
      .getFilteredPriceList(apiEndPoints.superAdminContainerPriceList, this.changeCityId)
      .subscribe({
        next: (response: any) => {
          this.priceListContainer = response.body.details;
          this.originalData = response.body.details;
          this.uniqueContainerNames = this.getUniqueContainerNames();
          this.uniqueContainerCapacities = this.getUniqueContainerCapacities();
        },
        error: (error) => {
          console.error('Error fetching container prices:', error);
          this.toastr.error('Failed to load container price list', 'Error');
        },
      });
  }

  initialContainerPriceList() {
    this.masterService
      .getContainerPriceList(apiEndPoints.containerPriceList)
      .subscribe({
        next: (response: any) => {
          this.priceListContainer = response.body.details;
          this.originalData = response.body.details;
          this.uniqueContainerNames = this.getUniqueContainerNames();
          this.uniqueContainerCapacities = this.getUniqueContainerCapacities();
        },
        error: (error) => {
          console.error('Error fetching container prices:', error);
          this.toastr.error('Failed to load container price list', 'Error');
        },
      });
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(
      this.priceListContainer
    );
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'ContainerList.xlsx');
  }

  getUniqueContainerNames(): string[] {
    return Array.from(
      new Set(
        this.priceListContainer.map((container: any) => container.containerName)
      )
    );
  }

  getUniqueContainerCapacities(): string[] {
    return Array.from(
      new Set(
        this.priceListContainer.map(
          (container: any) => container.containerCapacity
        )
      )
    );
  }

  toggleFilter(filterType: string): void {
    if (filterType === 'name') {
      this.filterByName = true;
      this.filterByCapacity = false; // Hide capacity filter if name filter is toggled
    } else if (filterType === 'capacity') {
      this.filterByCapacity = true;
      this.filterByName = false; // Hide name filter if capacity filter is toggled
    }
  }
}
